import {
  TechnicianClockRegister,
  TecnicianTreeMapClockData,
} from "../components/charts/tim-toa/types";

export function formatDataChartClockRegisterEmployee(
  data: TechnicianClockRegister
): TecnicianTreeMapClockData[] {
  return [
    {
      name: "Total batidas completas",
      value: data.total_batidas_completas,
      technicians: data.tecnicos,
    },
    {
      name: "Total batidas inconsistentes",
      value: data.total_batidas_inconsistentes,
      technicians: data.tecnicos,
    },
  ];
}
